import Checkbox from './checkbox.vue';

export default Checkbox;
